export default "__VITE_ASSET__Jrk6mliE__"